import React from "react";
import StorePhoto from "../../../images/landing/newphotos/esg-empresa.jpg";
import "../LandingAboutSectionOne/style.css";
import "../../landing.css";
import localeText from "../../../../locale";

const items = [
  { icon: "pi pi-verified", title: "lp2StoreItem1Title", desc: "lp2StoreItem1Desc" },
  { icon: "pi pi-map-marker", title: "lp2StoreItem2Title", desc: "lp2StoreItem2Desc" },
  { icon: "pi pi-percentage", title: "lp2StoreItem3Title", desc: "lp2StoreItem3Desc" },
  { icon: "pi pi-shopping-bag", title: "lp2StoreItem4Title", desc: "lp2StoreItem4Desc" },
];

const LandingStoreSection = () => {
  return (
    <section
      className="full-width py-8"
      style={{ backgroundColor: "var(--extra-soft)" }}
      id="store-conveniado"
    >
      <div className="eyebrow-text mb-2">{localeText("lp2StoreEyebrow")}</div>
      <div className="grid align-items-start pb-4">
        <div className="col-12 lg:col-6">
          <div
            className="font-bold text-4xl md:text-5xl line-height-2 title"
            style={{ color: "var(--extra-green)" }}
          >
            {localeText("lp2StoreTitle")}
          </div>
          <div className="text-lg mt-3" style={{ color: "var(--extra-body)", maxWidth: "46ch" }}>
            {localeText("lp2StoreDescription")}
          </div>
        </div>
        <div className="col-12 lg:col-6">
          <div
            className="negocio-photo"
            style={{ backgroundImage: `url(${StorePhoto})` }}
            role="img"
            aria-label="Loja física conveniada Extraconomy"
          />
        </div>
      </div>

      <div className="negocio-card">
        <div className="grid grid-nogutter">
          {items.map((item) => (
            <div key={item.title} className="col-12 md:col-6 negocio-cell">
              <div className="negocio-item">
                <i
                  className={item.icon}
                  style={{ color: "var(--extra-green)", fontSize: "1.6rem" }}
                ></i>
                <div className="font-bold text-lg mt-2" style={{ color: "var(--extra-ink)" }}>
                  {localeText(item.title)}
                </div>
                <div className="text-sm mt-1" style={{ color: "var(--extra-body)" }}>
                  {localeText(item.desc)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LandingStoreSection;
